const { listPrograms } = require('./list-programs')

exports.getProgram = async function (state, programId, { unfiltered = false } = {}) {
  // We are only getting user programs unless unfiltered is passed as true
  const programs = await listPrograms(state, { unfiltered })
  const program = programs.find(program => program.id === programId)
  if (program) {
    return program
  }

  const error = new Error(`Program with id ${programId} not found`)
  error.status = 404
  throw error
}
